module.exports = __webpack_public_path__ + "img/a11y-onionskin_jp.16c3025.jpg";